import {
  Auth0Context,
  type Auth0ContextInterface,
  type GetTokenSilentlyOptions,
  initialContext,
} from '@auth0/auth0-react';
import type { ReactNode } from 'react';

const DEMO_HOST = import.meta.env.VITE_DEMO_HOSTNAME;

export function isDemoMode(): boolean {
  return window.location.host === DEMO_HOST;
}

const DEMO_TOKEN = 'demo-access-token';

const demoUser = {
  email: 'demo@liquorstore.tech',
  sub: 'demo|000000000000000000000000',
  name: 'Demo User',
};

/**
 * getAccessTokenSilently that returns the sentinel demo token.
 *
 * The Auth0 SDK types this as an overloaded function with three call signatures.
 * We satisfy all overloads by returning either a verbose response object or the
 * plain token string based on the `detailedResponse` option, matching the real
 * Auth0 SDK behavior without any type casts.
 */
function getAccessTokenSilently(
  options?: GetTokenSilentlyOptions
): Promise<{ id_token: string; token_type: string; access_token: string; expires_in: number }>;
function getAccessTokenSilently(options?: GetTokenSilentlyOptions): Promise<string>;
function getAccessTokenSilently(options?: GetTokenSilentlyOptions) {
  if (options?.detailedResponse) {
    return Promise.resolve({
      id_token: DEMO_TOKEN,
      token_type: 'Bearer',
      access_token: DEMO_TOKEN,
      expires_in: 86400,
    });
  }

  return Promise.resolve(DEMO_TOKEN);
}

const demoContext: Auth0ContextInterface = {
  ...initialContext,
  isAuthenticated: true,
  isLoading: false,
  user: demoUser,
  getAccessTokenSilently,
  loginWithRedirect: () => Promise.resolve(),
  logout: () => Promise.resolve(),
};

export function DemoAuthProvider({ children }: { children: ReactNode }) {
  return <Auth0Context.Provider value={demoContext}>{children}</Auth0Context.Provider>;
}
